import { render, staticRenderFns } from "./PrivateForm.vue?vue&type=template&id=f37566f8&scoped=true&"
import script from "./PrivateForm.vue?vue&type=script&lang=js&"
export * from "./PrivateForm.vue?vue&type=script&lang=js&"
import style0 from "./PrivateForm.vue?vue&type=style&index=0&id=f37566f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37566f8",
  null
  
)

export default component.exports